// What the person is told once when another device continued a tasting and this one took its copy.
// Kept in memory: a notice nobody saw before the page closed has nothing left to say, since the
// tasting in the list already is the newer copy.
import { useSyncExternalStore } from "react";

export interface DraftNotice {
  readonly runId: string;
  readonly title: string;
}

let notices: readonly DraftNotice[] = [];
const listeners = new Set<() => void>();

function emit(next: readonly DraftNotice[]): void {
  notices = next;
  listeners.forEach((listener) => {
    listener();
  });
}

export function pushNotice(notice: DraftNotice): void {
  emit([...notices.filter((held) => held.runId !== notice.runId), notice]);
}

/** Forgets the notices shown, so each is told once. */
export function clearNotices(shown: readonly DraftNotice[]): void {
  const kept = notices.filter((held) => !shown.includes(held));
  if (kept.length !== notices.length) emit(kept);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useDraftNotices(): readonly DraftNotice[] {
  return useSyncExternalStore(
    subscribe,
    () => notices,
    () => notices,
  );
}

/** Tests start from nothing told. */
export function resetNotices(): void {
  emit([]);
}
